var BootstrapMenu = require('bootstrap-menu');

export default {
    props: {
        permission: String,
        guestShareId: String,
        objectType: String,
        objectId: String,
        updateInfoSelector: String,
    },

    data: {},

    connect() {
    },

    events: [{
        name: 'click',
        handler(ev) {
            connection.getJson('/Share/TogglePermission', {
                type: 'post',
                data: {
                    guestShareId: this.guestShareId,
                    objectType: this.objectType,
                    objectId: this.objectId,
                    permission: this.permission,
                },
            }).then((response) => {
                $(this.el).find('.fa').removeClass('bi-check').removeClass('bi-x').addClass(response.hasPermission ? 'bi-check' : 'bi-x');
                $(this.updateInfoSelector).html(response.permissions);
            });
        }
    }],

}
